// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"17967": "c1fc0782","35545": "7ea9faf9","59066": "28465eef","83922": "0684a6ab","89066": "47e4a6fa","90494": "28966746",}[chunkId] + ".css"
}